module.exports = __webpack_public_path__ + "img/shopNum7.ce5a50f2.png";